import { useOrganization, useUser } from "@clerk/react-router";
import { posthog } from "posthog-js";
import { useEffect } from "react";

export function PosthogInit() {
  useEffect(() => {
    posthog.init("phc_huKSxI8BZD1rvbdi8OaAbEdN63eVl9wcxSaQLw6e3H3", {
      api_host: "https://eu.i.posthog.com",
      person_profiles: "identified_only",
      autocapture: false,
      capture_pageview: false,
    });

    if (location.hostname === "anylawyer.com") {
      posthog.opt_in_capturing();
    }
  }, []);

  return null;
}

export function PosthogUser() {
  const { user, isLoaded: userLoaded } = useUser();
  const { organization, membership, isLoaded: orgLoaded } = useOrganization();

  useEffect(() => {
    if (userLoaded && orgLoaded && user) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        currentOrgId: organization?.id,
        currentOrgName: organization?.name,
        currentOrgRole: membership?.role,
      });
    } else if (userLoaded && !user) {
      posthog.reset();
    }
  }, [userLoaded, orgLoaded, user, organization, membership]);

  return null;
}
